<template>
  <transition name="swiper">
    <div
      class="full-photo-swiper"
      v-show="config.show"
      :style="{
        paddingTop: `${topNotOverflow ? statusBarHeight : 0}px`,
        background: '#000'
      }"
    >
      <div
        @touchmove.self.prevent.stop
        v-swiper:imgViwer="swiperConfig"
        class="swiper-container"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in config.list"
            :key="index"
          >
            <div
              class="swiper-zoom-container-outer"
              :style="{
                height: `calc(100% - ${statusBarHeight}px)`
              }"
            >
              <div class="swiper-zoom-container">
                <img :src="typeof item === 'object' ? item.img : item" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="full-photo-swiper-nav" v-if="config.list.length > 1">
        {{ activeIndex + 1 }} / {{ config.list.length }}
      </div>

      <div
        class="full-photo-top-btn-list"
        :style="{ top: statusBarHeight + 'px' }"
      >
        <div class="full-photo-swiper-img-text" v-if="imgText">
          {{ imgText }}
        </div>

        <div class="full-photo-swiper-back-btn" @click="$emit('close')">
          <slot name="closeIcon">
            <img src="~images/common/photo-back.png" alt="" />
          </slot>
        </div>

        <div
          v-if="rightBtn"
          class="full-photo-swiper-download-btn"
          @click="$emit('handleRight')"
        >
          <slot name="rightBtn"></slot>
        </div>
        <div class="full-photo-swiper-download-btn" @click="downloadImg" v-else>
          <img
            v-if="!config.hideDownloadIcon"
            src="~images/common/photo-download.png"
            alt=""
          />
          <p>保存</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { versionfunegt, isCanHideNavigationBar } from 'lib/tools/utils'
import { getStatusBarHeight } from 'utils/tool.js'

export default {
  props: {
    config: {
      type: Object,
      default: () => ({
        list: [],
        index: 0,
        show: false
      })
    },
    topNotOverflow: {
      type: Boolean,
      default: false
    },
    enablePullRefresh: Boolean, // 页面是否开启了下拉刷新
    showAppDownLoadBtn: {
      type: Boolean,
      default() {
        if (this.$isServer) return false
        return (
          this.$platform.isYixinliApp &&
          versionfunegt(this.$route.query._version, '5.8.0')
        )
      }
    },
    rightBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visited: false, //相册是否被打开
      activeIndex: 0,
      statusBarHeight: 0
    }
  },
  mounted() {
    this.getStatusBarHeight()
  },
  computed: {
    swiperConfig() {
      /* eslint-disable */
      const { zoom, loop } = this.config
      let config = {
        zoom: false,
        loop: true,
        lazy: true,
        on: {
          click: () => this.$emit('close'),
          slideChange: () => {
            if (this.imgViwer.realIndex >= 0) {
              this.activeIndex = this.imgViwer.realIndex
              // 手动触发的slideChange才外派事件
              if (this.visited) {
                this.$emit('slideChange', this.activeIndex)
              }
            }
          }
        }
      }
      if (typeof zoom !== 'undefined') {
        config.zoom = zoom
      }
      if (typeof loop !== 'undefined') {
        config.loop = loop
      }
      return config
    },
    imgText() {
      const { activeIndex, config } = this
      return typeof config.list[activeIndex] === 'object'
        ? config.list[activeIndex].text
        : ''
    }
  },
  methods: {
    getStatusBarHeight() {
      if (this.$isServer) return
      const { isYixinliApp } = this.$platform
      const canHideNavigationBar = isCanHideNavigationBar(this.$platform)
      if (isYixinliApp && canHideNavigationBar) {
        getStatusBarHeight().then(h => {
          this.statusBarHeight = h
          console.info('statusBarHeight:', this.statusBarHeight)
        })
      }
    },
    downloadImg() {
      if (this.showAppDownLoadBtn) {
        this._download()
      } else {
        this.$toast({
          text: '长按图片即可保存',
          time: 2000,
          zIndexTop: true
        })
      }
    },
    _download() {
      this.$toast({
        text: '正在保存图片...',
        zIndexTop: true
      })
      const { activeIndex, config } = this
      const curImg = config.list[activeIndex]
      const url = typeof curImg === 'object' ? curImg.img : curImg
      this.$bridge
        .downloadImage({
          url
        })
        .then(obj => {
          const { success } = obj
          if (success) {
            this.$bridge.showMessage({
              content: '保存成功',
              type: 'success'
            })
          } else {
            this.$bridge.showMessage({
              content: '保存失败',
              type: 'error'
            })
          }
          this.$emit('appDownloadImgCallback', obj) // 外部埋点
        })
    }
  },
  watch: {
    ['config.show'](val) {
      if (!this.$isServer) {
        if (!!val) {
          this.imgViwer.slideTo(this.config.index, 0)
          this.$nextTick(() => {
            this.visited = true
          })
          this.getStatusBarHeight()
        } else {
          this.imgViwer.zoom.out()
          this.visited = false
        }

        if (this.enablePullRefresh && this.$platform.isYixinliApp) {
          this.$bridge.isPullRefreshEnable({ enable: !!val ? 0 : 1 })
        }
      }
    }
  }
}
</script>

<style lang="scss">
$topSize: 88px;

.full-photo-swiper {
  position: fixed;
  width: 10rem;
  left: 50%;
  margin-left: -5rem;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.99);
  z-index: 1000;
  .swiper-container {
    flex: 1;
  }
  .swiper-slide {
    width: 10rem;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    overflow: hidden;
    z-index: initial;
  }

  .swiper-zoom-container-outer {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 80px;
    box-sizing: border-box;
    .swiper-zoom-container {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .full-photo-top-btn-list {
    position: fixed;
    width: 10rem;
    height: $topSize;
    left: 50%;
    margin-left: -5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .full-photo-swiper-nav {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    bottom: constant(safe-area-inset-bottom);
    bottom: env(safe-area-inset-bottom);
    height: $topSize;
    display: flex;
    align-items: center;
    color: #fff;
    font-size: 26px;
    line-height: 1;
    text-shadow: rgba(0, 0, 0, 0.9);
  }
  .full-photo-swiper-back-btn {
    position: absolute;
    left: 0;
    // width: $topSize;
    // height: $topSize;
    background: #000;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 44px;
      height: 44px;
      object-fit: cover;
    }
  }
  .full-photo-swiper-download-btn {
    position: absolute;
    right: 30px;
    height: $topSize;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #f3f4f5;
    img {
      width: 38px;
      height: 38px;
      object-fit: cover;
      margin-right: 9px;
    }
  }
  .full-photo-swiper-img-text {
    position: absolute;
    left: 0;
    width: 100%;
    color: #fff;
    line-height: 1.25;
    font-size: 28px;
    padding: 30px;
    background: rgba(0, 0, 0, 1);
    text-align: center;
    box-sizing: border-box;
  }
}
.swiper-enter-active,
.swiper-leave-active {
  transition: opacity 0.5s;
}
.swiper-enter,
.swiper-leave-to {
  opacity: 0;
}
</style>
